import { PageHeader } from "../../components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import Chat from "./team/Chat";
import Training from "./team/Training";
import Checklists from "./team/Checklists";
import DealerPortalAdmin from "./team/DealerPortal";

export default function Team() {
  return (
    <div className="space-y-6" data-testid="team-page">
      <PageHeader eyebrow="Ekip" title="Ekip Merkezi" subtitle="Ustalarla destek sohbeti, eğitim ve sertifika takibi, bayi/iş ortağı portalı ve komisyonlar." />
      <Tabs defaultValue="chat" urlTab>
        <TabsList className="flex-wrap h-auto"><TabsTrigger value="chat" data-testid="ttab-chat">Destek Sohbeti</TabsTrigger><TabsTrigger value="training" data-testid="ttab-training">Eğitim & Sertifika</TabsTrigger><TabsTrigger value="checklists" data-testid="ttab-checklists">Kontrol Listeleri</TabsTrigger><TabsTrigger value="dealers" data-testid="ttab-dealers">Bayi Portalı</TabsTrigger></TabsList>
        <TabsContent value="chat" className="mt-4"><Chat /></TabsContent>
        <TabsContent value="training" className="mt-4"><Training /></TabsContent>
        <TabsContent value="checklists" className="mt-4"><Checklists /></TabsContent>
        <TabsContent value="dealers" className="mt-4"><DealerPortalAdmin /></TabsContent>
      </Tabs>
    </div>
  );
}
